{
  "title": "Импорт КЕ",
  "actions": {
    "newImport": "Новый импорт",
    "cancelImport": "Отменить импорт",
    "cancelConfirm": "Отменить импорт? Уже записанные КЕ останутся в БДКЕ.",
    "downloadTemplate": "Скачать шаблон CSV",
    "issuesReport": "Отчёт об ошибках",
    "resultsExport": "Выгрузить результат"
  },
  "form": {
    "importType": "Тип импорта",
    "flat": "Плоский список (CSV)",
    "graph": "Граф (JSON)",
    "ciType": "Тип КЕ",
    "ciTypeHint": "Для графа поле недоступно: типы берутся из узлов файла.",
    "templateHint": "Шаблон содержит колонку ci_id и колонки атрибутов выбранного типа КЕ. Для КЕ, входящих в композицию, добавьте колонку composed_of_ci_id, для удаления записей — колонку ci_deleted.",
    "file": "Файл",
    "conflictPolicy": "При совпадении с существующей КЕ",
    "streamHint": "Файл передаётся потоком, окно нужно держать открытым до конца приёма.",
    "start": "Начать импорт"
  },
  "error": {
    "fileExtension": "Для этого типа импорта нужен файл {{extension}}.",
    "fileNotFlat": "Файл начинается как JSON: для плоского списка нужен CSV.",
    "fileNotGraph": "Файл не начинается с объекта JSON: для графа нужен файл графа."
  },
  "policy": {
    "MERGE": "Слить с существующей",
    "SKIP": "Пропустить строку",
    "ERROR": "Считать ошибкой"
  },
  "status": {
    "RECEIVING": "Приём файла",
    "QUEUED": "В очереди",
    "RUNNING": "Выполняется",
    "DONE": "Завершено",
    "DONE_WITH_ERRORS": "Завершено с ошибками",
    "CANCELLED": "Отменено",
    "REJECTED": "Отклонено",
    "ABORTED": "Приём оборван",
    "FAILED": "Ошибка"
  },
  "stage": {
    "RECEIVE": "Приём файла",
    "VALIDATE": "Проверка",
    "ORDER": "Порядок",
    "IDENTIFY": "Идентификация",
    "WRITE": "Запись",
    "FINISH": "Завершение"
  },
  "counters": {
    "rowTotal": "Строк в файле",
    "created": "Создано",
    "merged": "Слито",
    "unchanged": "Без изменений",
    "skipped": "Пропущено",
    "links": "Связей",
    "errors": "Ошибок",
    "deleted": "Удалено",
    "notFound": "Не найдено",
    "linkErrors": "Ошибок по связям"
  },
  "result": {
    "rows_one": "{{value}} строка",
    "rows_few": "{{value}} строки",
    "rows_many": "{{value}} строк",
    "rows_other": "{{value}} строки",
    "created": "создано {{value}}",
    "merged": "слито {{value}}",
    "skipped": "пропущено {{value}}",
    "links": "связей {{value}}",
    "errors": "ошибок {{value}}",
    "unchanged": "без изменений {{value}}",
    "deleted": "удалено {{value}}",
    "notFound": "не найдено {{value}}"
  },
  "jobs": {
    "graph": "Граф",
    "search": "Поиск по имени файла",
    "columns": {
      "file": "Файл",
      "status": "Статус",
      "progress": "Ход",
      "createdAt": "Время запуска"
    },
    "filters": {
      "active": "Активные",
      "errors": "С ошибками",
      "mine": "Только мои"
    },
    "progress": "{{percent}} % · {{processed}} из {{total}}",
    "receiving": "Идёт приём файла",
    "queuedBehind": "Ждёт завершения {{name}}",
    "queued": "Ждёт своей очереди",
    "aborted": "Соединение прервалось на приёме, КЕ не создавались",
    "rejected": "Отклонено на приёме",
    "failed": "Импорт прерван"
  },
  "details": {
    "format": "Формат",
    "conflictPolicy": "При совпадении",
    "author": "Запустил",
    "startedAt": "Начато",
    "elapsed": "Идёт",
    "duration": "Длительность",
    "progress": "{{processed}} из {{total}} строк",
    "rate": "{{rate}} КЕ/с · осталось ≈ {{remaining}}"
  },
  "issues": {
    "title": "Проблемные строки",
    "columns": {
      "line": "Строка файла",
      "element": "Элемент",
      "level": "Статус",
      "stage": "Этап",
      "ci": "КЕ в БДКЕ",
      "message": "Сообщение",
      "record": "Запись"
    },
    "level": {
      "ERROR": "Ошибка",
      "CONFLICT": "Конфликт"
    },
    "kind": {
      "NODE": "узел {{number}}",
      "LINK": "связь {{number}}"
    },
    "ciStatus": {
      "DELETED": "удалена",
      "NOT_FOUND": "не найдена",
      "FORBIDDEN": "нет доступа"
    },
    "source": {
      "line": "Строка {{number}} файла",
      "NODE": "Узел {{number}}",
      "LINK": "Связь {{number}}",
      "extraValue": "лишнее значение",
      "unparsed": "не разобран — как в файле",
      "truncated": "Показаны первые 8 КБ записи из {{size}}",
      "pretty": "С отступами",
      "raw": "Как в файле",
      "missing": "Текст записи не сохранён: задание выполнено до того, как отчёт стал его хранить."
    }
  },
  "ciTypes": {
    "title": "По типам КЕ",
    "noCIType": "Тип не определён",
    "notInModel": "нет в модели",
    "pending": "Разрез появится, когда задание завершится",
    "pendingHint": "Исходы по записям и их разрез снимаются один раз при завершении — при любом исходе, включая отмену и сбой.",
    "columns": {
      "ciType": "Тип КЕ",
      "total": "Всего"
    },
    "outcome": {
      "created": "Создано",
      "merged": "Слито",
      "unchanged": "Без изменений",
      "skipped": "Пропущено",
      "reference": "Ссылка",
      "deleted": "Удалено",
      "not_found": "Не найдено",
      "not_processed": "Не обработано",
      "error": "Ошибок"
    }
  }
}
